import {
  analyticsIdentify,
  analyticsTrack,
  identifyUserTimezone,
  buildAnalyticsConsentPayload,
  extractUserConsent,
} from './application/javascripts/analytics_util';

import ahoy from 'ahoy.js';
import createAhoyEvent from './application/javascripts/payments/stripe/analytics';
import trackEvent from './application/javascripts/tracking';
import { dispatchScriptLoadedEvent, ready } from './application/javascripts/utils';

// import files not directly referenced. Most of these setup event handlers or
// call some function that needs to be ran when the pack bundle is loaded.
import './application/javascripts/url/clean-params';

window.analyticsTrack = analyticsTrack;
window.analyticsIdentify = analyticsIdentify;
window.identifyUserTimezone = identifyUserTimezone;
window.createAhoyEvent = createAhoyEvent;
window.buildAnalyticsConsentPayload = buildAnalyticsConsentPayload;
window.trackEvent = trackEvent;
window.extractUserConsent = extractUserConsent;
window.dispatchScriptLoadedEvent = dispatchScriptLoadedEvent;
window.ready = ready;

// These values are the same as above but are also set to be globally available
// within webpack compiled scripts. This is handled in environment.js. They are
// set on the window to satisy any expectations about how they are called.
window.Cookies = Cookies;
window.ahoy = ahoy;
window.$ = $;
